'use client';
import cn from 'classnames';
import './LoadingGrid.style.scss';

type LoadingGridProps = {
  className?: string;
  numItemsToShow?: number;
};

function LoadingGrid({ className, numItemsToShow = 8 }: LoadingGridProps) {
  return (
    <div>
      <div className={'CompleteTheLookRecGrid-item-grid'}>
        {Array.from({ length: numItemsToShow }).map((_, index) => (
          <div
            key={index}
            className='LoadingCard'
          >
            <div className='LoadingCard-visual-container'>
              <div className='loading-img' />
            </div>
            <div className='LoadingCard-title-container'>
              <div className='loading-brand' />
              <div className='loading-name' />
              <div className='loading-price' />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LoadingGrid;
